import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToastService } from 'src/app/shared/toast/toast.service';
import { CandidatosApiService } from 'src/app/core/services/candidatos-api.service';
import { CatalogosApiService } from 'src/app/core/services/catalogos-api.service';
import { EstudiosAcademicosApiService } from 'src/app/core/services/estudios-academicos-api.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-carga-cv',
  standalone: false,
  templateUrl: './carga-cv.component.html',
  styleUrl: './carga-cv.component.scss'
})
export class CargaCvComponent {
  //pasos = ['Selecciona tu CV', 'Datos personales', 'Experiencia laboral', 'Estudios académicos', 'Cursos y/o certificaciones', 'Idiomas', 'Confirmación'];
  pasos = ['Selecciona tu CV'];
  pasoActual = 1;
  puedeAvanzar= true;

  fileBase64: string = '';
  selectedFile: File | null = null;
  fileSizeError: boolean = false;
  errorMessage = '';
  maxSize = 3 * 1024 * 1024; // 2MB
  jsonCV: any = {};
  banderacargocv: boolean = false;

  experiencia: any = [];

  personalForm: FormGroup;
  experienciaForm: FormGroup;
  formEstudios: FormGroup;
  formCursos: FormGroup;
  formIdiomas: FormGroup;

  showExperienciaForm = false;
  showFormEstudios = false;
  showFormCursos = false;
  showFormIdiomas = false;

  editExperienciaIndex: number | null = null;
  editEstudioIndex: number | null = null;
  editCursosIndex: number | null = null;
  editIdiomasIndex: number | null = null;

  catalogoPuestos: any = [];
  catalogoSueldos: any = [];
  catalogoTipoCursos: any = [];
  catalogoIdiomas: any = [];
  catalogoNivelManejoIdiomas: any = [];

  estudios: any = [];
  estudiosNivel: any = [
    {
      "id": 3, "descripcion": "Carrera Técnica Trunca"
    },{
      "id": 2, "descripcion": "Otro"
    },{
      "id": 1, "descripcion": "Secundaria"
    },{
      "id": 12, "descripcion": "Licenciatura Pasante"
    },{
      "id": 11, "descripcion": "Licenciatura"
    },{
      "id": 10, "descripcion": "Licenciatura Trunca"
    },{
      "id": 9, "descripcion": "Bachillerato/Preparatoria"
    },{
      "id": 8, "descripcion": "Carrera Comercial Titulado"
    },{
      "id": 7, "descripcion": "Carrera Comercial"
    },{
      "id": 6, "descripcion": "Carrera Comercial Trunca"
    },{
      "id": 5, "descripcion": "Carrera Técnica Titulado"
    },{
      "id": 4, "descripcion": "Carrera Técnica"
    },{
      "id": 21, "descripcion": "Maestría Titulado"
    },{
      "id": 19, "descripcion": "Maestría"
    },{
      "id": 20, "descripcion": "Maestría Pasante"
    },{
      "id": 18, "descripcion": "Maestría Trunca"
    },{
      "id": 16, "descripcion": "Diplomado/Postgrado Pasante"
    },{
      "id": 17, "descripcion": "Diplomado/Postgrado Titulado"
    },{
      "id": 15, "descripcion": "Diplomado/Postgrado"
    },{
      "id": 14, "descripcion": "Diplomado/Postgrado Trunco"
    },{
      "id": 13, "descripcion": "Licenciatura Titulado"
    },{
      "id": 31, "descripcion": "Secundaria Trunca"
    },{
      "id": 30, "descripcion": "Primaria Trunca"
    },{
      "id": 29, "descripcion": "Certificación de Oficio"
    },{
      "id": 28, "descripcion": "Bachillerato/Preparatoria Trunco"
    },{
      "id": 26, "descripcion": "Primaria"
    },{
      "id": 25, "descripcion": "Doctorado Titulado"
    },{
      "id": 24, "descripcion": "Doctorado Pasante"
    },{
      "id": 23, "descripcion": "Doctorado"
    },{
      "id": 22, "descripcion": "Doctorado Trunco"
    },{
      "id": 33, "descripcion": "Ingeniería"
    }
  ];

  institucionAcademica: any = [
    {"id":2, "descripcion": "Instituto Politécnico Nacional"},
    {"id":1, "descripcion": "Centro de Estudios Universitarios Monterrey"},
    {"id":3, "descripcion": "Instituto Panamericano de Alta Dirección de Empres"},
    {"id":36, "descripcion": "Universidad Tecnológica de México"},
    {"id":35, "descripcion": "Universidad La Salle"},
    {"id":34, "descripcion": "Universidad Autónoma del Estado de Morelos"},
    {"id":33, "descripcion": "Instituto Tec. y de Estudios Sup. de Occidente"},
    {"id":5, "descripcion": "Instituto Tec. y de Estudios Sup. de Monterrey"},
    {"id":4, "descripcion": "Instituto Tecnológico Autónomo de México"},
    {"id":40, "descripcion": "Universidad Autónoma de Baja California Sur"},
    {"id":39, "descripcion": "Universidad Autónoma de Baja California"},
    {"id":38, "descripcion": "Universidad Autónoma de Aguascalientes"},
    {"id":37, "descripcion": "Universidad Anáhuac"},
    {"id":43, "descripcion": "Universidad Autónoma de Nayarit"},
    {"id":42, "descripcion": "Universidad Autónoma de Guadalajara"},
    {"id":41, "descripcion": "Universidad Autónoma de Chihuahua"},
    {"id":46, "descripcion": "Universidad Autónoma de Zacatecas"},
    {"id":45, "descripcion": "Universidad Autónoma de Yucatán"},
    {"id":44, "descripcion": "Universidad Autónoma de Nuevo León"},
    {"id":53, "descripcion": "Universidad de las Américas Distrito Federal"},
    {"id":51, "descripcion": "Universidad de Guadalajara"},
    {"id":52, "descripcion": "Universidad de Guanajuato"},
    {"id":50, "descripcion": "Universidad de Colima"},
    {"id":49, "descripcion": "Universidad Autónoma Metropolitana"},
    {"id":48, "descripcion": "Universidad Autónoma del Estado de México"},
    {"id":54, "descripcion": "Universidad de Monterrey"},
    {"id":61, "descripcion": "Universidad Juárez Autónoma de Tabasco"},
    {"id":60, "descripcion": "Universidad José Vasconcelos de Oaxaca"},
    {"id":59, "descripcion": "Universidad Intercontinental"},
    {"id":58, "descripcion": "Universidad Iberoamericana"},
    {"id":57, "descripcion": "Universidad del Valle de México"},
    {"id":55, "descripcion": "Universidad del Mar"},
    {"id":62, "descripcion": "Universidad Justo Sierra"},
    {"id":69, "descripcion": "Centros de Estudios Tec. Ind. y de Servicios"},
    {"id":68, "descripcion": "Otra"},
    {"id":67, "descripcion": "Universidad Virtual"},
    {"id":65, "descripcion": "Universidad Panamericana"},
    {"id":66, "descripcion": "Universidad Veracruzana"},
    {"id":63, "descripcion": "Universidad Nacional Autónoma de México"},
    {"id":70, "descripcion": "Centros de Bachillerato Tec. Ind. y de Servicios"},
    {"id":72, "descripcion": "Centro Universitario Grupo Sol"},
    {"id":71, "descripcion": "Colegio Nacional de Educación Profesional Técnica"},
    {"id":74, "descripcion": "Universidad del Norte"},
    {"id":76, "descripcion": "Universidad Metropolitana de Monterrey"},
    {"id":75, "descripcion": "Universidad Regiomontana"},
    {"id":77, "descripcion": "Universidad Tecmilenio"},
    {"id":78, "descripcion": "Universidad Autónoma de Coahuila"},
    {"id":79, "descripcion": "Institutos Tecnológicos"},
    {"id":84, "descripcion": "Institutos Comerciales"},
    {"id":81, "descripcion": "Universidades Tecnológicas Mexicanas"},
    {"id":85, "descripcion": "Universidad del Valle de Atemajac"},
    {"id":88, "descripcion": "Colegio de Bachilleres"},
    {"id":87, "descripcion": "Universidad del Noroeste"},
    {"id":86, "descripcion": "Universidad Univer"},
    {"id":101, "descripcion": "Universidad Autónoma de Chiapas"},
    {"id":100, "descripcion": "Universidad Autónoma de Campeche"},
    {"id":92, "descripcion": "Colegio de Ciencias y Humanidades/Preparatoria/Voc"},
    {"id":99, "descripcion": "Universidad Autónoma Benito Juárez de Oaxaca"},
    {"id":91, "descripcion": "Centro Educativo Grupo Cedva"},
    {"id":89, "descripcion": "Sistema Abierto"},
    {"id":102, "descripcion": "Universidad Autónoma de Ciudad Juárez"},
    {"id":103, "descripcion": "Universidad Autónoma de Durango"},
    {"id":104, "descripcion": "Universidad Autónoma de Guerrero"},
    {"id":105, "descripcion": "Universidad Autónoma de Puebla"},
    {"id":107, "descripcion": "Universidad Autónoma de Quintana Roo"},
    {"id":106, "descripcion": "Universidad Autónoma de Querétaro"},
    {"id":110, "descripcion": "Universidad Autónoma de Tamaulipas"},
    {"id":111, "descripcion": "Universidad Autónoma de Tlaxcala"},
    {"id":109, "descripcion": "Universidad Autónoma de Sinaloa"},
    {"id":108, "descripcion": "Universidad Autónoma de San Luis Potosí"},
    {"id":113, "descripcion": "Universidad Autónoma del Estado de Michoacán"},
    {"id":112, "descripcion": "Universidad Autónoma del Estado de Hidalgo"},
    {"id":116, "descripcion": "Universidad de Huejotzingo"},
    {"id":115, "descripcion": "Universidad de Michoacán"},
    {"id":114, "descripcion": "Universidad de Chapingo"},
    {"id":118, "descripcion": "Universidad de Sonora"},
    {"id":117, "descripcion": "Universidad de Negocios Isec"},
    {"id":128, "descripcion": "Universidad del Pedregal"},
    {"id":126, "descripcion": "Harmon Hall"},
    {"id":129, "descripcion": "Escuela Bancaria y Comercial"},
    {"id":123, "descripcion": "Universidad Popular Autónoma del Estado de Puebla"},
    {"id":122, "descripcion": "Universidad Latinoamericana"},
    {"id":121, "descripcion": "Universidad Latina"},
    {"id":120, "descripcion": "Universidad Icel"},
    {"id":119, "descripcion": "Universidad del Caribe"},
    {"id":132, "descripcion": "Universidades Politécnicas"},
    {"id":131, "descripcion": "Centro de Estudios Científicos y Tecnológicos"},
    {"id":130, "descripcion": "Universidad del Tercer Milenio"},
    {"id":140, "descripcion": "Universidad Tecnológica del Sur del Edo. de México"},
    {"id":138, "descripcion": "Tecnológ. de Estudios Superiores Cuautitlán Izcall"},
    {"id":137, "descripcion": "Universidad Pedagógica Nacional"},
    {"id":136, "descripcion": "Centros de Capacitación para el Trabajo Industrial"},
    {"id":135, "descripcion": "Universidad Internacional Tecnológica de Morelos"},
    {"id":134, "descripcion": "Universidad Cristobal Colón Veracruz"},
    {"id":133, "descripcion": "Universidad Tula Tepeji"},
    {"id":141, "descripcion": "Universidad de las Américas Puebla"},
    {"id":148, "descripcion": "Fundación Infantia, A.C."},
    {"id":147, "descripcion": "Centro Universitario Incarnate Word"},
    {"id":145, "descripcion": "Universidad de Londres"},
    {"id":146, "descripcion": "Universidad Internacional"},
    {"id":144, "descripcion": "Universidad del Tepeyac"},
    {"id":149, "descripcion": "Universidad Insurgentes"},
    {"id":151, "descripcion": "Universidad Alfonso Reyes"},
    {"id":150, "descripcion": "Universidad Aeronáutica en Querétaro"},
    {"id":152, "descripcion": "Aliat Universidades"},
  ].sort();

  carreras: any = [
    {"id":999,  "descripcion": "OTRO"},
    {"id":6,  "descripcion": "Análisis de Sistemas"},
    {"id":7,  "descripcion": "Antropología"},
    {"id":5,  "descripcion": "Agronomía/Agronegocios"},
    {"id":3,  "descripcion": "Administración"},
    {"id":2,  "descripcion": "Acuicultura"},
    {"id":8,  "descripcion": "Arqueología"},
    {"id":4,  "descripcion": "Administración y Gestión Pública"},
    {"id":1,  "descripcion": "Actuaría"},
    {"id":20, "descripcion": "Ciencias Físicas"},
    {"id":9,  "descripcion": "Arquitectura"},
    {"id":19, "descripcion": "Ciencias del Ejercicio/Educación Física"},
    {"id":18, "descripcion": "Cartografía"},
    {"id":16, "descripcion": "Ingeniería Bioquímica"},
    {"id":15, "descripcion": "Biología"},
    {"id":12, "descripcion": "Bellas Artes"},
    {"id":13, "descripcion": "Bibliotecología"},
    {"id":10, "descripcion": "Astronomía"},
    {"id":17, "descripcion": "Ingeniería en Biotecnología"},
    {"id":26, "descripcion": "Construcción Civil"},
    {"id":14, "descripcion": "Ingeniería Biofísica"},
    {"id":24, "descripcion": "Ciencias de la Comunicación"},
    {"id":23, "descripcion": "Licenciatura en Informática"},
    {"id":11, "descripcion": "Colegio de Ciencias y Humanidades/Preparatoria/Voc"},
    {"id":22, "descripcion": "Comercio Internacional"},
    {"id":21, "descripcion": "Ciencias Políticas"},
    {"id":27, "descripcion": "Contabilidad/Auditoría/Impuestos"},
    {"id":25, "descripcion": "Comunicación Social"},
    {"id":43, "descripcion": "Finanzas"},
    {"id":42, "descripcion": "Filosofía"},
    {"id":40, "descripcion": "Estadística"},
    {"id":39, "descripcion": "Enfermería"},
    {"id":35, "descripcion": "Economía y Finanzas"},
    {"id":36, "descripcion": "Educación"},
    {"id":29, "descripcion": "Dibujo Técnico"},
    {"id":33, "descripcion": "Diseño Industrial"},
    {"id":32, "descripcion": "Diseño Gráfico"},
    {"id":41, "descripcion": "Farmacia"},
    {"id":31, "descripcion": "Diseño de Vestuario/Textil/Modas"},
    {"id":30, "descripcion": "Diseño de Imagen y Sonido"},
    {"id":38, "descripcion": "Electrónica"},
    {"id":37, "descripcion": "Electricidad"},
    {"id":28, "descripcion": "Derecho"},
    {"id":46, "descripcion": "Fotografía"},
    {"id":34, "descripcion": "Ecología"},
    {"id":44, "descripcion": "Fisioterapia"},
    {"id":45, "descripcion": "Fonoaudiología"},
    {"id":47, "descripcion": "Gastronomía/Cocina"},
    {"id":59, "descripcion": "Ingeniería Comercial"},
    {"id":60, "descripcion": "Ingeniería Eléctrica"},
    {"id":58, "descripcion": "Ingeniería Civil"},
    {"id":56, "descripcion": "Ingeniería Química en Alimentos"},
    {"id":55, "descripcion": "Ingeniería Agrícola"},
    {"id":52, "descripcion": "Administración Hotelera"},
    {"id":53, "descripcion": "Ingeniería Otros"},
    {"id":51, "descripcion": "Historia"},
    {"id":50, "descripcion": "Hidráulica"},
    {"id":57, "descripcion": "Ingeniería Ambiental"},
    {"id":49, "descripcion": "Geología/Geomensura/Topografía/Geografía"},
    {"id":48, "descripcion": "Geografía"},
    {"id":54, "descripcion": "Ingeniería Aeroespacial"},
    {"id":67, "descripcion": "Ingeniería en Informática"},
    {"id":66, "descripcion": "Ingeniería Industrial"},
    {"id":65, "descripcion": "Ingeniería Hidráulico"},
    {"id":64, "descripcion": "Ingeniería Forestal"},
    {"id":62, "descripcion": "Ingeniería en Materiales"},
    {"id":78, "descripcion": "Literatura"},
    {"id":68, "descripcion": "Ingeniería Matemática"},
    {"id":63, "descripcion": "Ingeniería en Minas"},
    {"id":76, "descripcion": "Ingeniería en Transporte"},
    {"id":61, "descripcion": "Ingeniería Electrónica"},
    {"id":73, "descripcion": "Ingeniería Química"},
    {"id":74, "descripcion": "Ingeniería de Sonido"},
    {"id":71, "descripcion": "Ingeniería Pesquera/Cultivos Marinos"},
    {"id":70, "descripcion": "Ingeniería Naval"},
    {"id":77, "descripcion": "Laboratorio (Mecánica) Dental"},
    {"id":84, "descripcion": "Medio Ambiente"},
    {"id":75, "descripcion": "Ingeniería en Telecomunicaciones"},
    {"id":82, "descripcion": "Técnico Mecánico"},
    {"id":72, "descripcion": "Ingeniería Petrolera"},
    {"id":79, "descripcion": "Maestro Mayor de Obras"},
    {"id":80, "descripcion": "Marketing"},
    {"id":69, "descripcion": "Ingeniería Mecánica/Metalúrgica"},
    {"id":83, "descripcion": "Medicina"},
    {"id":93, "descripcion": "Perito Mercantil"},
    {"id":86, "descripcion": "Música"},
    {"id":81, "descripcion": "Matemáticas"},
    {"id":91, "descripcion": "Paisajismo"},
    {"id":89, "descripcion": "Odontología"},
    {"id":87, "descripcion": "Nutrición"},
    {"id":85, "descripcion": "Minería/Petróleo/Gas"},
    {"id":92, "descripcion": "Periodismo"},
    {"id":94, "descripcion": "Procesos/Calidad Total"},
    {"id":102,  "descripcion": "Relaciones Públicas"},
    {"id":90, "descripcion": "Otra Carrera"},
    {"id":101,  "descripcion": "Relaciones Internacionales"},
    {"id":100,  "descripcion": "Recursos Humanos"},
    {"id":88, "descripcion": "Oceanografía"},
    {"id":98, "descripcion": "Publicidad"},
    {"id":96, "descripcion": "Psicología"},
    {"id":95, "descripcion": "Técnico en Programación"},
    {"id":99, "descripcion": "Química"},
    {"id":108,  "descripcion": "Telecomunicaciones"},
    {"id":107,  "descripcion": "Tecnología Médica/Laboratorio"},
    {"id":97, "descripcion": "Pedagogía"},
    {"id":105,  "descripcion": "Sociología"},
    {"id":106,  "descripcion": "Técnico"},
    {"id":104,  "descripcion": "Seguridad Industrial"},
    {"id":103,  "descripcion": "Secretariado"},
    {"id":109,  "descripcion": "Terapia Ocupacional"},
    {"id":110,  "descripcion": "Trabajo Social"},
    {"id":126,  "descripcion": "Ingeniería en Computación"},
    {"id":127,  "descripcion": "Ingeniería en Economía y Finanzas"},
    {"id":124,  "descripcion": "Ingeniería Automotríz"},
    {"id":123,  "descripcion": "Biotecnología en Alimentos"},
    {"id":120,  "descripcion": "Mercadotecnia"},
    {"id":119,  "descripcion": "Sistemas"},
    {"id":111,  "descripcion": "Traducción/Intérprete"},
    {"id":117,  "descripcion": "Negocios Internacionales"},
    {"id":116,  "descripcion": "Ninguna"},
    {"id":125,  "descripcion": "Ingeniería en Alimentos"},
    {"id":114,  "descripcion": "Veterinaria"},
    {"id":115,  "descripcion": "Ingeniería en Sistemas"},
    {"id":121,  "descripcion": "Informática"},
    {"id":122,  "descripcion": "Trunco"},
    {"id":112,  "descripcion": "Transporte"},
    {"id":118,  "descripcion": "Impuestos"},
    {"id":128,  "descripcion": "Ingeniería en Industria Alimentaria"},
    {"id":113,  "descripcion": "Turismo"},
    {"id":129,  "descripcion": "Ingeniería Química Farmacobióloga"},
    {"id":145,  "descripcion": "Licenciatura en Farmacia"},
    {"id":146,  "descripcion": "Bioquímica Diagnóstica"},
    {"id":143,  "descripcion": "Ingeniería Biomédica"},
    {"id":142,  "descripcion": "Químico Farmacéutico Industrial"},
    {"id":141,  "descripcion": "Químico Bacteriólogo y Parasitólogo"},
    {"id":139,  "descripcion": "Técnico en Hotelería"},
    {"id":138,  "descripcion": "Técnico en Enfermería"},
    {"id":130,  "descripcion": "Agroalimentos"},
    {"id":136,  "descripcion": "Técnico en Computación"},
    {"id":144,  "descripcion": "Ingeniería Farmacéutica"},
    {"id":134,  "descripcion": "Otro Oficio"},
    {"id":140,  "descripcion": "Técnico en Informática"},
    {"id":132,  "descripcion": "Licenciatura en Electrónica"},
    {"id":137,  "descripcion": "Técnico en Electrónica"},
    {"id":148,  "descripcion": "Ingeniería Química en Petroquímica"},
    {"id":135,  "descripcion": "Técnico Eléctrico"},
    {"id":133,  "descripcion": "Tecnología en Alimentos"},
    {"id":131,  "descripcion": "Licenciatura en Electricidad"},
    {"id":147,  "descripcion": "Químico Farmacéutico Biólogo"},
    {"id":149,  "descripcion": "Ingeniería Química en Procesos Petroquímicos"},
    {"id":161,  "descripcion": "Estetocosmetología"},
    {"id":160,  "descripcion": "Ingeniería en Control y Automatización"},
    {"id":159,  "descripcion": "Ingeniería Química Industrial"},
    {"id":156,  "descripcion": "Monitoreo de Estudios Clínicos"},
    {"id":157,  "descripcion": "Desarrollo Organizacional"},
    {"id":158,  "descripcion": "Ingeniería en Seguridad Computacional"},
    {"id":153,  "descripcion": "Ciencias Tecnología del Petróleo y Petroquímica"},
    {"id":154,  "descripcion": "Ingeniería en Aeronáutica"},
    {"id":151,  "descripcion": "Ingeniería Energética"},
    {"id":155,  "descripcion": "Ingeniería Mecatrónica"},
    {"id":167,  "descripcion": "Instalaciones Hidráulicas y de Gas"},
    {"id":164,  "descripcion": "Estilismo Profesional"},
    {"id":165,  "descripcion": "Diseño de Imagen"},
    {"id":163,  "descripcion": "Cosmetología"},
    {"id":150,  "descripcion": "Ingeniería Química Petrolera"},
    {"id":166,  "descripcion": "Carpintería"},
    {"id":168,  "descripcion": "Mantenimiento Automotríz"},
    {"id":177,  "descripcion": "Soldadura y Pailería"},
    {"id":175,  "descripcion": "Repostería"},
    {"id":162,  "descripcion": "Técnico en Maquillaje"},
    {"id":173,  "descripcion": "Peritaje y Valuación"},
    {"id":172,  "descripcion": "Moldeado de Plástico"},
    {"id":170,  "descripcion": "Máquinas-Herramienta"},
    {"id":171,  "descripcion": "Metrología Dimencional"},
    {"id":176,  "descripcion": "Sistemas de Control Industrial"},
    {"id":185,  "descripcion": "Especialidad en Ginecología"},
    {"id":174,  "descripcion": "Refrigeración y Aire Acondicionado"},
    {"id":183,  "descripcion": "Secundaria"},
    {"id":182,  "descripcion": "Primaria"},
    {"id":181,  "descripcion": "Biotecnología Agropecuaria"},
    {"id":180,  "descripcion": "Tratamiento de Aguas"},
    {"id":169,  "descripcion": "Mantenimiento Industrial"},
    {"id":184,  "descripcion": "Especialidad en Pediatría"},
    {"id":186,  "descripcion": "Especialidad en Anestesiología"},
    {"id":179,  "descripcion": "Trafico de Mercancías y Tramitación Aduanal"},
    {"id":187,  "descripcion": "Especialidad en Medicina Interna"},
    {"id":188,  "descripcion": "Nanotecnología e Ingeniería Molecular"},
    {"id":190,  "descripcion": "Administración de Empresas Turísticas"},
    {"id":195,  "descripcion": "Ingeniería Electromecánica"},
    {"id":194,  "descripcion": "Ingeniería Aeronáutica en Manufactura"},
    {"id":193,  "descripcion": "Manufactura de Aeronaves"},
    {"id":192,  "descripcion": "Mantenimiento de Aeronaves"},
    {"id":191,  "descripcion": "Aviónica"}
  ].sort();

  cursos: any[] = [];
  idiomas:any = [];

  constructor(
    private candidatosApiService: CandidatosApiService,
    private catalogosApiService: CatalogosApiService,
    private estudiosAcademicosApiService: EstudiosAcademicosApiService,
    private toastService: ToastService,
    private fb: FormBuilder,
    private http: HttpClient) {

    this.personalForm = this.fb.group({
      nombre: ['', [Validators.required, Validators.pattern('^[a-zA-ZÁÉÍÓÚáéíóúÑñ ]+$')]],
      apellidos: ['', [Validators.required, Validators.pattern('^[a-zA-ZÁÉÍÓÚáéíóúÑñ ]+$')]],
      correo: ['', [Validators.required, Validators.email]],
      celular: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
      entidadFederativa: ['', Validators.required],
      municipio: ['', Validators.required],
      perfil: ['', Validators.required]
    });

    this.experienciaForm = this.fb.group({
      puesto: ['', Validators.required],
      actualExp: [false],
      empresa: ['', Validators.required],
      fechaInicioExp: ['', Validators.required],
      fechaFinExp: ['', Validators.required],
      descripcion: ['', Validators.required],
    });

    this.formEstudios = this.fb.group({
      nivel: ['', Validators.required],
      institucion: ['', Validators.required],
      titulo: ['', Validators.required],
      anioInicio: ['', Validators.required],
      anioFin: ['', Validators.required],
      enProceso: [false],
      // descripcion: ['', Validators.required]
    });

    this.formCursos = this.fb.group({
      tipoCurso: ['', Validators.required],
      institucionCurso: ['', Validators.required],
      tituloCurso: ['', Validators.required],
      fechaInicioCurso: ['', Validators.required],
      fechaFinCurso: ['', Validators.required]
    });

    this.formIdiomas = this.fb.group({
      idioma: ['', Validators.required],
      nivelManejo: ['', Validators.required]
    });
  }

  actualizarPaso(nuevoPaso: number) {
    if (this.pasoActual <= this.pasos.length && this.puedeAvanzar) {
      switch(this.pasoActual) {
        case 1: this.obtieneInfoCVAI();
          break;
      }
      this.pasoActual = nuevoPaso;
    }else {
      console.warn("Formulario inválido. No se puede avanzar.");
    }
  }

  cargarCV(event: any) {
    const file: File = event.target.files[0];
    this.errorMessage = '';

    if (file) {
      const validTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];

      if (!validTypes.includes(file.type)) {
        this.fileSizeError = true;
        this.errorMessage = 'El archivo debe ser PDF o Word (.doc, .docx).';
        this.selectedFile = null;
        return;
      }

      if (file.size > this.maxSize) {
        this.fileSizeError = true;
        this.errorMessage = 'El archivo no debe superar los 2MB.';
        this.selectedFile = null;
        return;
      }

      this.selectedFile = file;
      
      this.convertirBase64(file);
    }
  }

  obtieneInfoCVAI() {
    if (!this.selectedFile) {
      this.toastService.show('Por favor selecciona un archivo CV primero', 'warning');
      return;
    }

    console.log('🔄 Probando método directo primero...');
    
    // Probar primero el método directo
    this.candidatosApiService.obtieneDescripcionPuestoAIDirecto(this.selectedFile).subscribe(
        (data: any) => {
          this.banderacargocv = true;
            this.toastService.show('¡Sugerencia actualizada con IA!', 'success');
            
            /*this.jsonCV = JSON.parse(data.perfil);*/

            this.personalForm.patchValue({
              nombre: this.jsonCV?.nombre || '',
              apellidos: this.jsonCV?.primer_apellido + ' ' + this.jsonCV?.segundo_apellido || '',
              correo: this.jsonCV?.email || '',
              celular: this.jsonCV?.telefono || '',
              entidadFederativa: this.jsonCV?.domicilio?.entidad_federativa || '',
              municipio: this.jsonCV?.domicilio?.municipio || '',
              perfil: this.jsonCV?.perfil_profesional || ''
            });

            this.experiencia = this.jsonCV?.experiencia_laboral || [];
            this.estudios = this.jsonCV?.formacion_academica || [];
            this.cursos = this.jsonCV?.cursos_certificaciones || [];
            this.idiomas = this.jsonCV?.idiomas || [];

            // Intentar extraer email de la respuesta raw primero
            console.log('📄 Respuesta raw del procesamiento:', data.raw);
            let emailFromRaw = null;
            if (data.raw) {
              const rawText = String(data.raw);
              console.log('📄 Analizando respuesta raw completa...');
              
              // Múltiples patrones para extraer email
              const patterns = [
                /email[:\s]+([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/i,
                /correo[:\s]+([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/i,
                /mail[:\s]+([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/i,
                /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/  // Cualquier email en el texto
              ];
              
              for (const pattern of patterns) {
                const match = rawText.match(pattern);
                if (match && match[1]) {
                  emailFromRaw = match[1];
                  console.log('✅ Email extraído de la respuesta raw con patrón:', pattern, '→', emailFromRaw);
                  break;
                }
              }
              
              // También intentar extraer de JSON si está embebido
              if (!emailFromRaw) {
                const jsonMatch = rawText.match(/\{[\s\S]*"email"[\s\S]*\}/i);
                if (jsonMatch) {
                  try {
                    const parsed = JSON.parse(jsonMatch[0]);
                    emailFromRaw = parsed.email || parsed.correo || parsed.mail;
                    if (emailFromRaw) {
                      console.log('✅ Email extraído de JSON embebido en raw:', emailFromRaw);
                    }
                  } catch (e) {
                    // Ignorar error de parsing
                  }
                }
              }
            }

            // Obtener perfil completo usando proceso_id para extraer el email
            const procesoId = data.procesoId || localStorage.getItem('proceso_id');
            console.log('🆔 proceso_id obtenido:', procesoId);
            
            if (emailFromRaw) {
              // Si encontramos el email en la respuesta raw, usarlo directamente
              console.log('📧 Usando email de la respuesta raw');
              this.enviarCorreoAcceso(emailFromRaw);
            } else if (procesoId && procesoId !== '0') {
              // Esperar un poco antes de llamar al servicio (el perfil puede no estar listo inmediatamente)
              console.log('⏳ Esperando 2 segundos antes de obtener perfil...');
              setTimeout(() => {
                this.obtenerPerfilYEnviarCorreo(procesoId);
              }, 2000);
            } else {
              // Fallback: intentar con email del formulario si está disponible
              const email = this.personalForm.get('correo')?.value || this.jsonCV?.email;
              if (email) {
                console.log('📧 Usando email del formulario como fallback');
                this.enviarCorreoAcceso(email);
              } else {
                console.warn('⚠️ No se encontró email en ninguna fuente');
              }
            }
        },
        (error: {}) => {
          console.error('❌ Error con método directo, probando con proxy...');
          
          // Si falla el método directo, probar con proxy
          this.candidatosApiService.obtieneDescripcionPuestoAI(this.selectedFile!).subscribe(
            (data: any) => {
              // Simular retraso de 30 segundos también para el proxy
              setTimeout(() => {
                console.log('✅ Éxito con proxy!');
                this.toastService.show('¡Sugerencia actualizada con IA!', 'success');
                this.jsonCV = JSON.parse(data.perfil);

                this.personalForm.patchValue({
                  nombre: this.jsonCV.nombre,
                  apellidos: this.jsonCV.primer_apellido + ' ' + this.jsonCV.segundo_apellido,
                  correo: this.jsonCV.email,
                  celular: this.jsonCV.telefono,
                  entidadFederativa: this.jsonCV.domicilio.entidad_federativa,
                  municipio: this.jsonCV.domicilio.municipio,
                  perfil: this.jsonCV.perfil_profesional
                });

                this.experiencia = this.jsonCV.experiencia_laboral;
                this.estudios = this.jsonCV.formacion_academica;
                this.cursos = this.jsonCV.cursos_certificaciones;
                this.idiomas = this.jsonCV.idiomas;
                
                // Intentar extraer email del jsonCV primero (ya está parseado)
                const emailFromCV = this.jsonCV?.email || this.personalForm.get('correo')?.value;
                
                // Obtener perfil completo usando proceso_id para extraer el email
                const procesoId = localStorage.getItem('proceso_id');
                console.log('🆔 proceso_id obtenido (proxy):', procesoId);
                
                if (emailFromCV) {
                  // Si encontramos el email en el CV parseado, usarlo directamente
                  console.log('📧 Usando email del CV parseado');
                  this.enviarCorreoAcceso(emailFromCV);
                } else if (procesoId && procesoId !== '0') {
                  // Esperar un poco antes de llamar al servicio (el perfil puede no estar listo inmediatamente)
                  console.log('⏳ Esperando 2 segundos antes de obtener perfil (proxy)...');
                  setTimeout(() => {
                    this.obtenerPerfilYEnviarCorreo(procesoId);
                  }, 2000);
                } else {
                  console.warn('⚠️ No se encontró email ni proceso_id');
                }
                
                // Finalizar bandera después del retraso
                this.banderacargocv = true;
              }, 30000); // 30 segundos
            },
            (proxyError: {}) => {
              console.error('❌ Error también con proxy:', proxyError);
              this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
              // Finalizar bandera en caso de error
              this.banderacargocv = false;
            }
          );
        }
      );
  }

  isInvalid(controlName: string) {
    const control = this.personalForm.get(controlName);
    return control?.invalid && control?.touched;
  }

  convertirBase64(file: File): void {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.fileBase64 = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  getExtensionArchivo(fileName: string): string {
    return fileName.split('.').pop()?.toLowerCase() || ''; // Extrae la extensión
  }

  /**
   * Obtiene el perfil completo del candidato usando proceso_id y luego envía el correo
   */
  obtenerPerfilYEnviarCorreo(procesoId: string | number) {
    console.log('🔍 Obteniendo perfil con proceso_id:', procesoId);
    
    const url = `${environment.urlAppian}/obtener-resume`;
    const headers = new HttpHeaders({
      'appian-api-key': environment.appianApiKey,
      'Accept': 'application/json'
    });
    const params = new HttpParams().set('proceso_id', procesoId.toString());

    console.log('📡 Llamando a:', url, 'con proceso_id:', procesoId);

    // Intentar primero como texto para ver qué devuelve realmente
    this.http.get(url, { headers, params, responseType: 'text' }).pipe(
      map((res: string) => {
        console.log('📥 Respuesta completa de obtener-resume (texto):', res);
        console.log('📥 Longitud de respuesta:', res?.length);
        
        if (!res || res.trim() === '') {
          console.warn('⚠️ Respuesta vacía');
          return { error: 'empty_response' };
        }

        // Detectar si la respuesta indica que no se encontró el resume
        if (res.toLowerCase().includes('resume no encontrado') || 
            res.toLowerCase().includes('no encontrado') ||
            res.toLowerCase().includes('not found')) {
          console.warn('⚠️ Resume no encontrado en Appian aún');
          return { error: 'resume_not_found', message: res };
        }

        // Intentar parsear como JSON
        try {
          const parsed = JSON.parse(res);
          console.log('✅ Respuesta parseada como JSON:', parsed);
          
          const isEmptyObj = parsed && typeof parsed === 'object' && Object.keys(parsed).length === 0;
          const isEmptyArr = Array.isArray(parsed) && parsed.length === 0;
          if (isEmptyObj || isEmptyArr) {
            console.warn('⚠️ JSON vacío');
            return { error: 'empty_json' };
          }
          
          const perfil = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : parsed;
          console.log('📋 Perfil procesado:', perfil);
          console.log('📋 Campos disponibles en perfil:', perfil ? Object.keys(perfil) : 'N/A');
          return perfil;
        } catch (e) {
          console.warn('⚠️ No es JSON válido, intentando extraer información del texto...');
          console.log('📄 Contenido del texto:', res.substring(0, 500)); // Primeros 500 caracteres
          
          // Intentar extraer JSON del texto si está embebido
          const jsonMatch = res.match(/\{[\s\S]*\}/);
          if (jsonMatch) {
            try {
              const parsed = JSON.parse(jsonMatch[0]);
              console.log('✅ JSON extraído y parseado del texto:', parsed);
              const perfil = Array.isArray(parsed) && parsed.length > 0 ? parsed[0] : parsed;
              return perfil;
            } catch (e2) {
              console.warn('⚠️ No se pudo parsear el JSON extraído');
            }
          }
          
          // Intentar extraer email directamente del texto
          const emailMatch = res.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/);
          if (emailMatch && emailMatch[1]) {
            console.log('✅ Email extraído del texto:', emailMatch[1]);
            return { email: emailMatch[1] };
          }
          
          return { error: 'no_email_found', message: res };
        }
      }),
      catchError((error: any) => {
        console.error('❌ Error al obtener perfil con proceso_id:', error);
        console.error('❌ Detalles del error:', {
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          error: error.error
        });
        return of(null);
      })
    ).subscribe((perfil: any) => {
      console.log('🔍 Analizando perfil para extraer email...');
      console.log('🔍 Perfil recibido:', perfil);
      
      // Si hay un error, intentar fallbacks
      if (perfil?.error) {
        console.warn('⚠️ Error al obtener perfil:', perfil.error);
        
        // Si el resume no está encontrado, intentar con otros métodos
        if (perfil.error === 'resume_not_found') {
          console.log('🔄 Resume no encontrado, intentando obtener email de otras fuentes...');
          this.intentarEnviarCorreoConFallbacks();
          return;
        }
      }
      
      // Intentar diferentes campos donde puede estar el email
      const email = perfil?.email || 
                    perfil?.correo || 
                    perfil?.emailAddress ||
                    perfil?.mail ||
                    (perfil && typeof perfil === 'object' && !perfil.error ? Object.values(perfil).find((v: any) => 
                      typeof v === 'string' && v.includes('@') && v.includes('.')
                    ) as string : null);

      if (email && typeof email === 'string' && email.includes('@')) {
        console.log('✅ Email obtenido del perfil:', email);
        this.enviarCorreoAcceso(email);
      } else {
        console.warn('⚠️ No se pudo obtener el email del perfil');
        console.warn('⚠️ Estructura del perfil:', JSON.stringify(perfil, null, 2));
        
        // Intentar con fallbacks
        this.intentarEnviarCorreoConFallbacks();
      }
    });
  }

  /**
   * Intenta obtener el email de múltiples fuentes y enviar el correo
   */
  intentarEnviarCorreoConFallbacks() {
    console.log('🔄 Intentando obtener email de múltiples fuentes...');
    
    // 1. Intentar del formulario
    const emailForm = this.personalForm.get('correo')?.value;
    if (emailForm && emailForm.includes('@')) {
      console.log('📧 Email encontrado en formulario:', emailForm);
      this.enviarCorreoAcceso(emailForm);
      return;
    }
    
    // 2. Intentar del jsonCV
    const emailCV = this.jsonCV?.email;
    if (emailCV && emailCV.includes('@')) {
      console.log('📧 Email encontrado en jsonCV:', emailCV);
      this.enviarCorreoAcceso(emailCV);
      return;
    }
    
    // 3. Intentar extraer de la respuesta raw almacenada
    const procesoId = localStorage.getItem('proceso_id');
    if (procesoId && procesoId !== '0') {
      // Intentar de nuevo después de más tiempo (el resume puede tardar en procesarse)
      console.log('⏳ Esperando 5 segundos más antes de reintentar...');
      setTimeout(() => {
        this.obtenerPerfilYEnviarCorreo(procesoId);
      }, 5000);
      return;
    }
    
    console.error('❌ No se pudo obtener el email de ninguna fuente disponible');
    console.warn('⚠️ El correo no se enviará automáticamente. El usuario puede solicitarlo más tarde desde su perfil.');
  }

  /**
   * Envía correo electrónico con código de seguridad después de procesar el CV
   */
  enviarCorreoAcceso(email: string) {
    if (!email || email.trim() === '') {
      console.warn('⚠️ No hay email disponible para enviar correo de acceso');
      return;
    }

    console.log('📧 Enviando correo de acceso a:', email);
    this.candidatosApiService.postGeneraCodigoSeguridad(email).subscribe(
      (data: any) => {
        console.log('✅ Correo de acceso enviado exitosamente:', data);
        // No mostrar toast adicional para no interrumpir el flujo
        // El mensaje informativo ya está mostrado en la UI
      },
      (error: any) => {
        console.error('❌ Error al enviar correo de acceso:', error);
        // No mostrar error al usuario para no interrumpir el flujo
        // El mensaje informativo ya está mostrado en la UI
      }
    );
  }

  agregarExperiencia() {
    // this.form.reset({ actual: false });
    this.editExperienciaIndex = null;
    this.showExperienciaForm = true;
    // this.catalogosApiService.getSueldos().subscribe(
    //   (data: any) => {
    //     let _payload: any = data.payload;
    //     this.catalogoSueldos = _payload.data;
    //     this.getExperienciaLaboral();
    //     this.toastService.show('¡Guardado con éxito!', 'success');
    //   }, (error: {}) => {
    //     console.error(error);
    //     this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
    //   }
    // );
  }

  experienciaLaboralID: number = 0;
  editarExperiencia(index: number) {
    const exp = this.experiencia[index];
    this.experienciaLaboralID = exp.idEmpresa;
    this.editExperienciaIndex = index;
    this.showExperienciaForm = true; 

    const [mes, anio] = exp.periodo?.fecha_inicio.split('/');
    const fechaInicioFormateada = `${anio}-${mes.padStart(2, '0')}`;

    const [mes2, anio2] = exp.periodo?.fecha_fin.split('/');
    const fechaFinFormateada = `${anio2}-${mes2.padStart(2, '0')}`;

    this.experienciaForm.patchValue({
      puesto: exp.puesto,
      empresa: exp.empresa,
      fechaInicioExp: fechaInicioFormateada,
      fechaFinExp: fechaFinFormateada,
      descripcion: exp.funciones,
      actualExp: exp.periodo.estoyLaborandoActualmente
    });
  }

  eliminarExperiencia(index: number) {
    // this.candidatosApiService.eliminarExperienciaLaboral(this.experiencia[index]?.idEmpresa).subscribe(
    //   (data: any) => {
    //     this.experiencia.splice(index, 1);
    //     this.toastService.show('¡Guardado con éxito!', 'success');
    //   }, (error: {}) => {
    //     console.error(error);
    //     this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
    //   }
    // );
  }

  esFormularioExperienciaValido(): boolean {
    const actual = this.experienciaForm.get('actual')?.value === true;
    const fechaFinDisabled = this.experienciaForm.get('fechaFinExp')?.disabled === true;
    return true;//this.form.valid;
  }

  cancelarExperiencia() {
    this.showExperienciaForm = false;
    // this.form.reset();
    // this.getExperienciaLaboral();
  }

  // Estudios Académicos
  getEstudio() {
    this.estudiosAcademicosApiService.getEstudiosAcademicos().subscribe(
      (data: {}) => {
        this.estudios = data;
      },
      (error: {}) => {
        console.error(error);
        this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
      }
    );
  }

  agregarEstudio() {
    //this.formEstudios.reset({ sigue: false });
    this.editEstudioIndex = null;
    this.showFormEstudios = true;
  }

  estudioIDEdicion: number = 0;
  editarEstudio(index: number) {
    const est = this.estudios[index];
    this.showFormEstudios = true; 
    this.editEstudioIndex = index;
    // this.formEstudios.reset(est);
    // if (est.sigue) {
    //   this.formEstudios.get('anioFin')?.disable();
    // }

    this.estudioIDEdicion = est.ues_id_estudio;

    const fechaInicio = est.fecha_inicio;
    const fechaFin = est.fecha_fin;

    const [mes, anio] = fechaInicio.split('/');
    const fechaInicioFormateada = `${anio}-${mes.padStart(2, '0')}`;

    const [mes2, anio2] = fechaFin.split('/');
    const fechaFinFormateada = `${anio2}-${mes2.padStart(2, '0')}`;

    this.formEstudios.patchValue({
      nivel: est.grado,
      institucion: est.institucion,
      titulo: est.carrera,
      anioInicio: fechaInicioFormateada,
      anioFin: fechaFinFormateada,
      enProceso: est.enProceso
    });
    // this.showFormEstudios = true;
  }

  eliminarEstudio(index: number) {
    this.estudiosAcademicosApiService.eliminarEstudios(this.estudios[index]?.ues_id_estudio).subscribe(
      (data: {}) => {
        this.toastService.show('¡Guardado con éxito!', 'success');
        this.getEstudio();
        this.estudios.splice(index, 1);
      },
      (error: {}) => {
        console.error(error);
        this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
      }
    );
  }

  cancelarEstudio() {
    this.showFormEstudios = false;
    // this.formEstudios.reset();
    this.getEstudio();
  }

  guardarEstudio() {
    const nuevo = this.formEstudios.getRawValue();

    const nivel = this.formEstudios.get('nivel')?.value;
    const institucion = this.formEstudios.get('institucion')?.value;
    const titulo = this.formEstudios.get('titulo')?.value;
    const fechaInicio = this.formEstudios.get('anioInicio')?.value;
    const fechaFin = this.formEstudios.get('anioFin')?.value;

    // const descripcion = this.formEstudios.get('descripcion')?.value;
    if (this.editEstudioIndex !== null) {
      this.estudiosAcademicosApiService.actualizarEstudios(this.estudioIDEdicion, nivel, institucion, titulo, fechaInicio, fechaFin).subscribe(
        (data: {}) => {
          this.toastService.show('¡Guardado con éxito!', 'success');
          if (this.editEstudioIndex !== null) {
            this.estudios[this.editEstudioIndex] = nuevo;
          }
          this.getEstudio();
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
    } else {
      this.estudiosAcademicosApiService.agregarEstudiosAcademicos(nivel, institucion, titulo, fechaInicio, fechaFin).subscribe(
        (data: {}) => {
          this.toastService.show('¡Guardado con éxito!', 'success');
          this.estudios.push(nuevo);
          this.getEstudio();
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
    }
    this.cancelarEstudio();
  }

  esFormularioEstudioValido(): boolean {
    const sigue = this.formEstudios.get('sigue')?.value === true;
    const anioFinDisabled = this.formEstudios.get('anioFin')?.disabled === true;
    return this.formEstudios.valid && (!sigue || anioFinDisabled);
  }

  // Cursos o certificaciones
  getCursos() {
    this.estudiosAcademicosApiService.getCursos().subscribe(
        (data: []) => {
          this.cursos = data;
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
  }

  agregarCursos() {
    //this.formEstudios.reset({ sigue: false });
    this.editCursosIndex = null;
    this.showFormCursos = true;
  }

  cursosIDEdicion: number = 0;
  editarCursos(index: number) {
    const est = this.cursos[index];
    this.cursosIDEdicion = est.idCurso;

    console.log(est);

    this.formCursos.patchValue({
      tipoCurso: est.idTipoCurso,
      institucionCurso: est.institucion,
      tituloCurso: est.nombre,
      fechaInicioCurso: est.mesIni + '/' + est.anioIni,
      fechaFinCurso: est.mesFin + '/' + est.anioFin
    });

    this.editCursosIndex = index;
    this.showFormCursos = true;
  }

  eliminarCursos(index: number) {
    console.log(index);
    console.log(this.cursos);
    console.log(this.cursos[index]);
    this.estudiosAcademicosApiService.eliminarCurso(this.cursos[index]?.idCurso).subscribe(
      (data: {}) => {
        this.toastService.show('¡Guardado con éxito!', 'success');
        this.getCursos();
        this.cursos.splice(index, 1);
      },
      (error: {}) => {
        console.error(error);
        this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
      }
    );
  }

  guardarCursos() {
    console.log(">>>>> guardar curso", this.cursosIDEdicion);
    // if (this.formCursos.invalid) return;
    const nuevo = this.formCursos.getRawValue();

    const tipoCurso = this.formCursos.get('tipoCurso')?.value;
    const institucionCurso = this.formCursos.get('institucionCurso')?.value;
    const tituloCurso = this.formCursos.get('tituloCurso')?.value;
    const fechaInicioCurso = this.formCursos.get('fechaInicioCurso')?.value;
    const fechaFinCurso = this.formCursos.get('fechaFinCurso')?.value;

    if (this.cursosIDEdicion > 0) {
      this.estudiosAcademicosApiService.actualizarCurso(this.cursosIDEdicion, tipoCurso, institucionCurso, tituloCurso, fechaInicioCurso, fechaFinCurso).subscribe(
        (data: {}) => {
          this.toastService.show('¡Guardado con éxito!', 'success');
          if (this.cursosIDEdicion !== null) {
            this.cursos[this.cursosIDEdicion] = nuevo;
          }
          this.getCursos();
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
    } else {
      this.estudiosAcademicosApiService.agregarCurso(tipoCurso, institucionCurso, tituloCurso, fechaInicioCurso, fechaFinCurso).subscribe(
        (data: {}) => {
          this.toastService.show('¡Guardado con éxito!', 'success');
          this.cursos.push(nuevo);
          this.getCursos();
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
    }
    this.cancelarCursos();
  }

  getDescripcionTipoCursoCatalogo(idCurso: string) {
    return this.catalogoTipoCursos.find((t:any)=> t.id === idCurso).descripcion || 'Sin despecificar';
  }

  cancelarCursos() {
    this.showFormCursos = false;
    //this.formCursos.reset();
  }

   // Idiomas
  getCatalogoIdiomas() {
    this.estudiosAcademicosApiService.getCaralogoIdiomas().subscribe(
        (data: []) => {
          this.catalogoIdiomas = data;
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
  }
  getCatalogoNivelManejoIdiomas() {
    this.estudiosAcademicosApiService.getCatalogoNivelManejoIdiomas().subscribe(
        (data: []) => {
          this.catalogoNivelManejoIdiomas = data;
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
  }

  getIdiomas() {
    this.estudiosAcademicosApiService.getIdiomas().subscribe(
        (data: []) => {
          this.idiomas = data;
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
  }

  agregarIdioma() {
    //this.formEstudios.reset({ sigue: false });
    this.editIdiomasIndex = null;
    this.showFormIdiomas = true;
  }

  idiomaIDEdicion: number = 0;
  editarIdioma(index: number) {
    const est = this.idiomas[index];
    this.idiomaIDEdicion = est.idIdioma;

    this.formIdiomas.patchValue({
      idioma: est.idIdioma,
      nivelManejo: est.idNivelManejo
    });

    this.editIdiomasIndex = index;
    this.showFormIdiomas = true;
  }

  eliminarIdioma(index: number) {
    this.estudiosAcademicosApiService.eliminarIdioma(this.idiomas[index]?.idIdioma).subscribe(
      (data: {}) => {
        this.toastService.show('¡Guardado con éxito!', 'success');
        this.getCursos();
        this.idiomas.splice(index, 1);
      },
      (error: {}) => {
        console.error(error);
        this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
      }
    );
  }

  guardarIdiomas() {
    console.log(">>>>> guardar curso", this.idiomaIDEdicion);
    // if (this.formCursos.invalid) return;
    const nuevo = this.formIdiomas.getRawValue();

    const idioma = this.formIdiomas.get('idioma')?.value;
    const nivelManejo = this.formIdiomas.get('nivelManejo')?.value;

    if (this.idiomaIDEdicion > 0) {
      this.estudiosAcademicosApiService.actualizarIdioma(idioma, nivelManejo).subscribe(
        (data: {}) => {
          this.toastService.show('¡Guardado con éxito!', 'success');
          if (this.idiomaIDEdicion !== null) {
            this.idiomas[this.idiomaIDEdicion] = nuevo;
          }
          this.getIdiomas();
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
    } else {
      this.estudiosAcademicosApiService.agregarIdioma(idioma, nivelManejo).subscribe(
        (data: {}) => {
          this.toastService.show('¡Guardado con éxito!', 'success');
          this.idiomas.push(nuevo);
          this.getIdiomas();
        },
        (error: {}) => {
          console.error(error);
          this.toastService.show('¡Ocurrió un problema, intenta más tarde!', 'danger');
        }
      );
    }
    this.cancelarIdiomas();
  }

  getDescripcionIdioma(id: number) {
    return this.catalogoIdiomas.find((i:any)=>i.id === id).descripcion;
  }

  getDescripcionNivelManejoIdioma(id: number) {
    return this.catalogoNivelManejoIdiomas.find((i:any)=>i.id === id).descripcion;
  }

  cancelarIdiomas() {
    // this.editIdiomasIndex = null;
    this.showFormIdiomas = false;
  }

}
